import React, { Component } from 'react';

import Avatar from 'material-ui/Avatar';

import AccountCircle from 'material-ui/svg-icons/action/account-circle';

import AppointmentForm from './AppointmentForm'

class SupporterProfile extends Component {

  render() {
    return (
      <div style={{textAlign: 'center', padding:'30px'}}>
        <Avatar
          size={120}
          icon={<AccountCircle />}
        />
        <p>{this.props.user.name}</p>
        <p>{this.props.user.email}</p>
        <AppointmentForm
          locale={this.props.locale}
          clientprefix={this.props.clientprefix}
          mailfooter={this.props.mailfooter}
          mailsender={this.props.mailsender}
          labels={this.props.labels}
          contact={this.props.user}
          user={this.props.user}
          mailTheme={this.props.mailTheme}
          sendMail={this.props.sendMail} />
      </div>
    )
  }
};

export default SupporterProfile;


// WEBPACK FOOTER //
// ./src/SupporterProfile.js